<template>
	<div id="app">
		<h1 class="keywords">Keywords, English Keywords, Asian food distributor America, Asian food
			distributor USA,
			Asian food distributors CA, Asian food distributors chicago, Chinese snacks wholesale,
			wholesale asian food distributors, Asian food distributors America, Asian food wholesale
			distributors new york, Asian snacks distributor, Asian food wholesale near me, Asian food
			products wholesale new york, chinese restaurant food supply, Asian food wholesale california,
			Asian snacks distributors los angeles, Asian food distributor houston, Asian food distributor
			near me, which company owns asianfoods?, Asian food importers, international food distribution
			companies, is Asian food becoming more popular?, Asian food beverage, Asian food distributors
			in california, Asian food distributors new york, wholesale asian food companies, Asian foods
			wholesale distributors, chinese food wholesale distributors, Asian food wholesale distributors
			near me, Asian food distributor houston, tx, chinese restaurant food supply, Asian food
			wholesale suppliers north America, Asian food distributors atlanta, chinese food supply, Asian
			ingredients wholesale, Asian food grocery near me, Asian food warehouse north America, Asian
			grocery supplies US, bulk asian food online, wholesale thai food America, chinese supermarket
			food supplier, chinese food supplier US, asian supermarket food wholesaler, asian
			distributors, japanese snacks wholesale usa, Asian wholesale website, korean food wholesale
			distributors, Asian wholesale food suppliers, oriental food distributors, Asian food wholesale
			chicago, Asian specialty foods, Asian food importers of America, Asian frozen food suppliers,
			Asian food distributors florida, Asian foods distributor seattle, 亚洲食品饮料北美, 美国亚洲食品公司,
			北美华人食品批发, 亚洲食品批发, 美国华人超市进货, 美国亚洲食品批发, 美国华人中国食品, 亚洲超市食品进货, 洛杉矶食品批发, 纽约食品批发公司, 华人超市供货商,
			美国食品批发公司华源, 华源芝加哥亚洲食品批发, 亚特兰大亚洲食品批发, 波士顿亚洲食品批发, 得克萨斯亚洲食品批发, 最受欢迎亚洲食品华源, 中国美食美国批发, 中国美食美国进货,
			北美独家代理中国食品, 美国超市批发, 中国食品批发美国, 北美亚洲餐厅食品进货, 美国中国餐厅食品批发, 美国亚裔食品批发公司, 中国食品饮料品牌美国, 亚洲食品全美独家代理,
			亚洲食品零售进货, 美国电商亚洲食品渠道, 亚洲食品餐饮供货, 中国食品饮料美国, 亚洲美妆品牌美国</h1>
		<h2 class="product-keywords">Keywords Master Lee US, Master Lee Chinese ready-to-eat brand USA,
			Master Lee prepared dishes, Master Lee authentic pre-made dishes America, Master Lee fresh
			taste fast food, Master Lee Cooked dumplings, cold noodles US, Fried Rice Noodle US, Rice ball
			brand, grill fish brand US, Master Lee Seafood, Steamed Dumpling US, Baozi brand US, English
			Keywords, Thai hom mali rice US, good Thai rice USA, Natural Ancient Farming rice, Thai
			fragrant rice, Does Thai rice taste good, ​The first brand of high-end fragrant rice in
			Thailand, English Keywords, China's first brand of sugar-free tea USA, Genki forest America,
			popular beverage US, trend brand drink US, sugar-free low-calory product America, Milk Tea
			Original America, Peach Sparkling Water north America, Genki Sparkling Water Lychee Flavor
			Cans, peach Oolong Tea north America, Citrus Sparkling Water, Yogurt Flavor Sparkling Water
			north America, White Strawberry coconut Flavor Soda Sparkling Water US, Black Grape Soda
			Sparkling Water US, Corn Silk Tea US, Sugar Free Oolong Tea US, Alienergy Electrolyte Water
			Grape Aloe US, Sparkling Water Winter Strawberry Flavor US, English Keywords, Mengniu America,
			healthy and delicious dairy products USA, mengniu icecream, English Keywords, Weilong Foods
			USA, weilong chinese snacks, weilong spicy, weilong latiao, Wei Long Konjac snacks, popular
			snacks of China, English Keywords, Arctic Ocean Soda America, orange juice flavored soda,
			Chinese popular soda America, Arctic Ocean orange Soda, Arctic Ocean Mandarin Soda, English
			Keywords, Shenghetang America, Shenghetang Herbal Jelly Guiling Paste, Shenghetang Tortoise
			Paste, Shenghetang Herbal Drink Ginseng Honey, sunity US, English Keywords, Haitian USA,
			Haitian soy sauce America, Haitian seasoning sauce, Haitian vinegar, Haitian oyster sauce,
			haday soy sauce, English Keywords, jinmailang US, jinmailang Dry Noodle Wide, jinmailang
			Seafood Flavor Noodles, jinmailang Japanese Pork Bone Soup Flavor Noodles, jinmailang Sour
			Hot Pork Bone Soup Flavor Noodles , jinmailang Chicken Mushroom Flavor Noodles, English
			Keywords, Daoxiangcun US, Daoxiangcun Sweetheart Cake with Honey, daoxiangcun Wife Cake,
			beijing snacks, Daoxiangcun snacks, Fruit Mochi Coconut Milk Flavor, English Keywords,
			Wanglaoji US, Wanglaoji tea, wanglaoji herbal beverage, 李先生美国, 加热即食美国, 加热即食第一品牌, 5分钟中华料理 ,
			新鲜快餐, 预制菜, 李先生冷面, 李先生炒饭, 李先生饭团, 李先生烤鱼, 李先生海鲜, 李先生蒸饺, 李先生包子系列, 泰国香纳兰米美国, 香纳兰泰国茉莉香米, 正宗泰国米美国,
			泰国品牌大米美国, 泰国皇室米, 泰国好大米, 元气森林美国, 元气森林 乳茶 浓香原味, 元气森林 白桃味苏打气泡水, 元气森林 荔枝气泡水 罐装, 元气森林 燃茶 桃香无糖乌龙茶饮料,
			元气森林 卡曼橘味苏打气泡水, 元气森林气泡水 海盐菠萝, 元气森林 白草莓 椰子味苏打气泡水, 元气森林 夏黑葡萄味苏打气泡水, 元气森林气泡水 海盐菠萝, 元气森林 满分微气泡果汁,
			元气森林 饮料北美, 蒙牛美国, 蒙牛纯甄牛奶美国, 蒙牛冰淇淋, 卫龙美国, 卫龙中国小吃零食北美, 卫龙辣条美国, 卫龙休闲零食, 好吃零食卫龙美国, 中国热门零食美国, ,
			北冰洋饮料美国, 北冰洋汽水美国, 北冰洋 橙汁汽水, 北冰洋 桔汁汽水, 生和堂美国, 生和堂龟苓膏北美, 美国龟苓膏, 海天酱油美国, 海天 味极鲜 特级酱油, 海天 老抽王, 海天
			生抽王, 海天 海鲜酱油, 海天 金标蚝油, 今麦郎美国, 今麦郎手打龙须面, 今麦郎 海鲜汤面, 今麦郎 日式猪骨汤面, 今麦郎 蘑菇鸡汤面, 今麦郎 酸辣猪骨, 稻香村美国,
			稻香村老婆饼美国, 稻香村枣花酥, 稻香村糕点美国, 稻香村休闲零食美国, 稻香村 爆浆麻薯 椰丝牛, 王老吉, 王老吉凉茶</h2>
		<pageHeader />
		<keep-alive>
			<router-view :key="$route.fullPath" v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive"></router-view>
		<pageFooter />
		<div class="toUp" @click="toTop">
			<img src="@/assets/images/toUp.png" alt="move to website top">
		</div>
	</div>
</template>

<script>
import pageHeader from "@/components/pageHeader";
import pageFooter from "@/components/pageFooter";
export default {
	name: "app",
	components: {
		pageHeader, pageFooter
	},
	mounted() {
		if (this.$i18n.locale === 'zh') document.title = '美国华源, 中国新潮食品北美第一平台, 汇聚中国最优质的食品饮料品牌, 美国地区亚洲食品供应商。';
		else document.title = 'OCM foods group is an  Asian food wholesaler, top famous Chinese food brands sell in USA, thousands of Products of Asian Snacks & Food wholesale.';
	},
	methods: {
		toTop: function () {
			window.scrollTo(0, 0);
		}
	},
	watch: {
		'$i18n.locale'(newValue) {
			if (newValue === 'zh') document.title = '美国华源, 中国新潮食品北美第一平台, 汇聚中国最优质的食品饮料品牌, 美国地区亚洲食品供应商。';
			else document.title = 'OCM foods group is an  Asian food wholesaler, top famous Chinese food brands sell in USA, thousands of Products of Asian Snacks & Food wholesale.';
		}
	}
}
</script>

<style lang="scss">
h1.keywords,
h2.product-keywords {
	font-size: 0;
}
.toUp {
	display: none;
}
@media only screen and (max-width: 767px) {
	.toUp {
		display: block;
		position: fixed;
		right: 0;
		bottom: 30%;
		z-index: 990;
	}
}
</style>
